import React, { useContext, useEffect, useMemo, useState } from "react";
import Close from "../../../../../images/Close.svg";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import
{
  GridColDef,
  GridAlignment,
  GridColumnVisibilityModel,
  GridValidRowModel,
  GridColumnHeaderParams
} from "@mui/x-data-grid-pro";
import { msgType, TableHeaderProps } from "../../../../../utils/types";
import
{
  AttendanceTypes,
  empType,
  Operation
} from "../../../../../utils/Enum.types";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { Title } from "../../../../../stories/Title/Title";
import Input from "../../../../../stories/Input/Input";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import { Button } from "../../../../../stories/Button/Button";
import { Checkbox } from "@mui/material";
import { Label } from "../../../../../stories/Label/Label";
import TextArea from "../../../../../stories/TextArea/TextArea";
import { AppContext } from "../../../../../context/context";
import { GetEmpAttendance } from "../../users/queries/queries";
import
{
  EmpMaster,
  EmpMasterEdge,
  EmpMasterOrderField,
  EmpQueryType,
  GetEmpResult,
  GetEmpVars
} from "../../users/queries/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import
{
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE
} from "../../../../../utils/constants";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { Keys } from "../../../../../utils/Enum.keys";
import { AddMomAttResult, AddMomAttVars, GetMomAttResult, GetMomAttVars, GetMomInviteesResult, GetMomInviteesVars } from "../queries/types";
import { AddMomAtt } from "../queries/mutations";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import MessageModal from "../../../../../customComponents/MessageModal";
import { GetMomAtt, GetMomAttCount, GetMomInvitees } from "../queries/query";

interface Props
{
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  ldgrID: number;
  name: string;
  operation: Operation;
}
const EmployeeAttendance = ( { setModalFlag, ldgrID, name, operation }: Props ) =>
{
  const { MinutesOfMeeting } = useAssetTableJson();
  const { state } = useContext( AppContext );
  const [ hasNextPage, setHasNextPage ] = useState<boolean>( true );
  const [ endCursor, setEndCursor ] = useState<string | null>( null );
  const [ columnVisibilityModel, setColumnVisibilityModel ] =
    useState<GridColumnVisibilityModel>( {} );

  const [ message, setMessage ] = useState<msgType>( emptyMessage );

  const [ employees, setEmployees ] = useState<EmpMasterEdge[]>( [] );

  const [ employeeType, setEmpType ] = useState<empType>( empType.NONE );

  const [ invitees, setInvitees ] = useState<string[]>( [] );

  const [ inviteeName, setInviteeName ] = useState( "" );

  const [ searchEmployee, setSearchEmployee ] = useState( "" );
  const [ presentEmps, setPresentEmps ] = useState<EmpMaster[]>( [] );

  const { customer_id, momID, projectID } = useUrlParams();

  const { user_details } = useLoggedInUserDetails();

  const selectedIds = useMemo( () =>
  {
    return presentEmps.map( ( emp ) => emp.id );
  }, [ presentEmps ] );

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    node: EmpMaster
  ) =>
  {
    const checked = ( e.target as HTMLInputElement ).checked;

    if ( checked )
    {
      setPresentEmps( ( prev ) => [ ...prev, node ] );
    } else setPresentEmps( presentEmps.filter( ( { id } ) => id !== node.id ) );
  };

  const [ AddAttendance, { loading: AddAttendanceLoading } ] = useMutation<
    AddMomAttResult,
    AddMomAttVars
  >( AddMomAtt, {
    onError: ( e ) =>
    {
      setMessage( {
        flag: true,
        message: e.message,
        operation: Operation.NONE
      } );
    }
  } );

  const [ GetAttendance, { data, loading, fetchMore } ] = useLazyQuery<
    GetEmpResult,
    GetEmpVars
  >( GetEmpAttendance );
  const [ GetAtt, { data: attData } ] = useLazyQuery<
    GetMomAttResult,
    GetMomAttVars
  >( GetMomAtt );

  const [ GetInvitees, { data: inviteesAtt } ] = useLazyQuery<
    GetMomInviteesResult,
    GetMomInviteesVars
  >( GetMomInvitees );

  useEffect( () =>
  {
    if ( customer_id && momID && projectID && operation === Operation.UPDATE )
    {
      GetInvitees( {
        variables: {
          customerID: customer_id,
          momID: momID,
          projectID,
          latest: true
        },
      } );
    }
  }, [ customer_id, GetInvitees, momID, projectID, operation, ] );
  useEffect( () =>
  {
    if ( customer_id && momID && projectID && operation === Operation.UPDATE )
    {
      GetAtt( {
        variables: {
          customerID: customer_id,
          momID,
          projectID,
          latest: true

        },
      } ).then( ( { data } ) =>
      {
        if ( data && data.GetMomAtt )
        {
          setPresentEmps( data.GetMomAtt.map( ( { empDetails } ) => empDetails ) );
        }
      } );
    }
  }, [
    customer_id,
    momID,
    GetAtt,
    attData,
    projectID,
    operation

  ] )

  const dynamicHeaders: TableHeaderProps[] = MinutesOfMeeting.Attended.map(
    ( header ) => ( {
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: ( params ) =>
      {
        if ( header.field === "status" )
        {
          return (
            <>
              <span
                className={
                  params.row.status === AttendanceTypes.Present
                    ? "font-green"
                    : "font-red"
                }
              >
                {" "}
                {params.row.status}
              </span>
            </>
          );
        } else if ( header.field === "id" )
        {
          return (
            <>
              <Checkbox
                checked={
                  selectedIds.includes( params.row.empNode.id ) ? true : false
                }
                onChange={( e ) =>
                {
                  handleCheckboxChange( e, params.row.empNode );
                }}
              />
              {params.row.id}
            </>
          );
        } else return params.value;
      }
    } )
  );

  const columns = [ ...dynamicHeaders ];

  useEffect( () =>
  {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.MOM_ATTENDED_DETAILS
    );
    if ( savedModel )
    {
      setColumnVisibilityModel( JSON.parse( savedModel ) );
    }
  }, [] );

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) =>
  {
    setColumnVisibilityModel( newModel );
    localStorage.setItem(
      ColumnVisibilityFor.MOM_ATTENDED_DETAILS,
      JSON.stringify( newModel )
    );
  };

  useEffect( () =>
  {
    if ( customer_id && ldgrID )
    {
      GetAttendance( {
        variables: {
          customer_id,
          after: null,
          first: ROWS_PER_PAGE,
          input: {
            queryType: EmpQueryType.BY_TYPE,
            empType:
              employeeType === empType.NONE
                ? [ empType.VENDOR_MANAGER, empType.TECHNICIAN ]
                : [ employeeType ],
            companyID: 0,
            ldgrID,
            siteID: 0,
            subsidiaryID: 0
          },
          orderBy: {
            direction: OrderDirection.ASC,
            field: EmpMasterOrderField.NAME
          },
          name: searchEmployee,
        },
      } );
    }
  }, [ customer_id, GetAttendance, employeeType, searchEmployee, ldgrID ] );

  const handleScroll = () =>
  {
    if ( hasNextPage && !loading )
    {
      fetchMore( {
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor
        },
        updateQuery: ( prevResult, { fetchMoreResult } ) =>
        {
          if ( !fetchMoreResult ) return prevResult;

          const newEdges = fetchMoreResult.GetEmp.edges;
          const pageInfo = fetchMoreResult.GetEmp.pageInfo;
          setEndCursor( pageInfo.endCursor );
          setHasNextPage( pageInfo.hasNextPage );

          const duplicateCheck = prevResult.GetEmp.edges.filter(
            ( { node: { id } } ) =>
              newEdges.findIndex( ( { node: { id: newId } } ) => newId === id ) !==
              -1
          );

          if ( duplicateCheck.length > 0 ) return prevResult;

          return {
            GetEmp: {
              edges: [ ...employees, ...newEdges ],
              pageInfo,
              totalCount: data ? data.GetEmp.totalCount! : 0
            }
          };
        }
      } );
    }
  };

  const rows: GridValidRowModel[] = useMemo( () =>
  {
    return data
      ? data.GetEmp.edges.map( ( { node }, index ) => ( {
        id: index + 1,
        employee_name: node.name,
        user_type: node.empType,
        empNode: node
      } ) )
      : [];
  }, [ data ] );

  useEffect( () =>
  {
    if ( data && !loading )
    {
      const newData = data.GetEmp.edges;

      if ( endCursor )
      {
        const updatedNewData = newData.map( ( newEmp ) =>
        {
          const filteredStudent = employees.find(
            ( employee ) => employee.node.id === newEmp.node.id
          );
          if ( filteredStudent )
          {
            return {
              ...newEmp,
              node: {
                ...newEmp.node
              }
            };
          }
          return newEmp;
        } );
        setEmployees( updatedNewData );
      } else
      {
        setEmployees( newData );
      }
      setEndCursor( data.GetEmp.pageInfo.endCursor );
    } // eslint-disable-next-line
  }, [ data, loading ] );

  const handleSubmit = () =>
  {
    if ( customer_id && momID && projectID )
    {
      AddAttendance( {
        variables: {
          customerID: customer_id!,
          user_details,
          input: {
            momID,
            empIds: selectedIds,
            invitees: invitees.join( ";" ),
            projectID
          }
        },
        refetchQueries: [
          {
            query: GetMomAttCount,
            variables: {
              customerID: customer_id,
              momID,
              projectID,
              latest: true
            }
          },
          {
            query: GetMomAttCount,
            variables: {
              customerID: customer_id,
              momID,
              projectID,
              latest: true,
            },
          },
          {
            query: GetMomAttCount,
            variables: {
              customerID: customer_id,
              momID,
              projectID: -1,
              latest: true,
            },
          },
          {
            query: GetMomAttCount,
            variables: {
              customerID: customer_id,
              momID,
              projectID: 0,
              latest: true,
            },
          },
          {
            query: GetEmpAttendance,
            variables: {
              customer_id,
              after: null,
              first: ROWS_PER_PAGE,
              input: {
                queryType: EmpQueryType.BY_TYPE,
                empType:
                  employeeType === empType.NONE
                    ? [ empType.VENDOR_MANAGER, empType.TECHNICIAN ]
                    : [ employeeType ],
                companyID: 0,
                ldgrID,
                siteID: 0,
                subsidiaryID: 0
              },
              orderBy: {
                direction: OrderDirection.ASC,
                field: EmpMasterOrderField.NAME
              },
              name: searchEmployee,
              kgidValue: 0
            }
          }
        ]
      } ).then( ( { data } ) =>
      {
        if ( data && data.AddMomAtt )
        {
          setMessage( {
            flag: true,
            message: "Attendance added successfully",
            operation: Operation.CREATE
          } );
        }
      } );
    }
  };

  return (
    <div className="att-emp-list">
      <div className="att-emp-list__title">
        <Title>Employee Attendance</Title>
        <img src={Close} alt="" onClick={() => setModalFlag( false )} />
      </div>
      <div className="att-emp-list__subtitle">
        <b>{name}</b>
      </div>
      <Input
        id="data_search"
        placeholder="Search..."
        onChange={( e ) =>
        {
          setSearchEmployee( e.target.value );
        }}
      />
      <div
        className={`att-emp-list__tableblock${ state.empSubType === empType.PMU && invitees.length === 0
          ? "--pmu"
          : state.empSubType === empType.PMU && invitees.length
            ? "--with-invitee"
            : ""
          }`}
      >
        <StyledDatagrid
          columns={columns}
          rows={rows}
          rowHeight={TABLE_ROW_HEIGHT}
          disableRowSelectionOnClick
          hideFooter
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={handleColumnVisibilityChange}
          onRowsScrollEnd={() =>
          {
            handleScroll();
          }}
        />
      </div>

      {state.empSubType === empType.PMU && (
        <div className="att-emp-list__invities">
          <div className="att-emp-list__invities--grid">
            <Label>Enter Person Name</Label>
            <Input
              onChange={( e ) =>
              {
                setInviteeName( e.target.value );
              }}
              value={inviteeName}
              onKeyDown={( e ) =>
              {
                if ( e.key === Keys.ENTER )
                {
                  setInvitees( ( prev ) => [ ...prev, inviteeName ] );
                  setInviteeName( "" );
                }
              }}
            />
            <Button
              mode="addnew"
              onClick={() =>
              {
                setInvitees( ( prev ) => [ ...prev, inviteeName ] );
                setInviteeName( "" );
              }}
            />
          </div>
          {invitees.length ? (
            <div className="att-emp-list__invities--list">
              {invitees.map( ( invitee, index ) =>
              {
                return (
                  <React.Fragment key={index}>
                    <span className="att-emp-list__invities--list--ele">
                      {invitee}{" "}
                      <img
                        src={Close}
                        alt="/"
                        onClick={() =>
                        {
                          setInvitees( ( prev ) =>
                            prev.filter( ( item ) => item !== invitee )
                          );
                        }}
                      />
                    </span>
                  </React.Fragment>
                );
              } )}
            </div>
          ) : null}
        </div>
      )}
      {/* {state.empSubType === empType.PMU && (
        <>
          <div className="att-emp-list__text-area">
            <Label>Enter Person Name</Label>
            <Input
              onChange={( e ) =>
              {
                setInviteeName( e.target.value );
              }}
              value={inviteeName}
              onKeyDown={( e ) =>
              {
                if ( e.key === Keys.ENTER )
                {
                  setInvitees( ( prev ) => [ ...prev, inviteeName ] );
                  setInviteeName( "" );
                }
              }}
            />
            <Button
              mode="addnew"
              onClick={() =>
              {
                setInvitees( ( prev ) => [ ...prev, inviteeName ] );
                setInviteeName( "" );
              }}
            />
          </div>
          <div>
            {invitees.map( ( invitee, index ) =>
            {
              return (
                <div key={index}>
                  <span>{invitee}</span>
                  <img
                    src={Close}
                    alt="/"
                    onClick={() =>
                    {
                      setInvitees( ( prev ) =>
                        prev.filter( ( item ) => item !== invitee )
                      );
                    }}
                  />
                </div>
              );
            } )}
          </div>
        </>
      )} */}

      <Button
        mode="save"
        onClick={handleSubmit}
        loading={AddAttendanceLoading}
      />
      <Button mode="cancel" onClick={() => setModalFlag( false )} />

      <MessageModal
        handleClose={() =>
        {
          setMessage( emptyMessage );
          if ( message.operation === Operation.CREATE )
          {
            setModalFlag( false );
          }
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default EmployeeAttendance;
